export const LINEA_UP_SUCCESS = 'LINEA_UP_SUCCESS';
export const LINEA_UP_MENU= 'LINEA_UP_MENU';
export const LINEA_UP_VERSION= 'LINEA_UP_VERSION';
